import { makeTicketGroupRoleCheck } from 'features/libra/lifecycle/lifecycleTypes'
import {
  getLibraTicketGroupAdminPermission,
  PERMISSION_CANTILEVER_CORE_ADMIN,
  type RolodexPermissionsValues,
} from 'types'

/** Admins always may. Omitted `roles` means admins only; an empty list allows anyone. */
export function checkCreateVersionPermission(
  hasPermissions: (perms: RolodexPermissionsValues[]) => boolean,
  groupId: string,
  roles: ReadonlyArray<string> | undefined
): boolean {
  return (
    hasPermissions([PERMISSION_CANTILEVER_CORE_ADMIN]) ||
    makeTicketGroupRoleCheck(
      hasPermissions,
      groupId
    )(roles ?? [getLibraTicketGroupAdminPermission(groupId)])
  )
}
